"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const S = __importStar(require("./RadioButton.styles"));
// TODO: make it uncontrolled based on condition. So that it can be used as both controlled and uncontrolled
exports.RadioButton = ({ selected, onPress, disabled, testID, accessibilityLabel, accessibilityHint, }) => {
    return (react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { testID: testID, onPress: onPress, accessibilityRole: "radio", accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, disabled: disabled },
        react_1.default.createElement(S.RadioButton, { selected: selected, disabled: disabled, accessibilityState: { selected, disabled }, testID: "radio-button" }, selected && react_1.default.createElement(S.Dot, null))));
};
